import client from '../../client'

export default {
  // 初期表示
  FirstDisplay: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/CommonMyPage/CommonMyPageFirstDisplay'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        jgcd: param.jgcd,
        trsq: param.trsq
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // 確認メール送信ボタン押下時 
  SendConfirmMail: param => {
    return new Promise((resolve, reject) => {
        var url = '/api/CommonMyPage/CommonMyPageSendConfirmMail'
        var qs = require('qs')
        var data = qs.stringify({
          ircd: param.ircd,
          userId: param.userId,
          ukno: param.ukno
        })
        var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      }
        client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/Common/MyPage/CommonMyPageApi.js